import http from "../services/http";

// MÉTODO SINCRONIZAR (TODOS)
async function listarPendencias(atualizarPendencias) {
  const api = await http("get", "v1/pendencias/listar", []);
  let dados = [];

  if (api.statusCode === 200) {
    dados = api?.response?.data;
    await atualizarPendencias({
      aviso_ferias: dados?.aviso_ferias,
      recibo_ferias: dados?.recibo_ferias,
      comprovante_rendimentos: dados?.comprovante_rendimentos,
      holerites: dados?.holerites,
      avaliacoes: dados?.avaliacoes,
      pdi: dados?.pdi,
      termos: dados?.termos,
      notificacoes: dados?.notificacoes,
      videos: dados?.videos,
      equipamentos: dados?.equipamentos,
      treinamentos: dados?.treinamentos,
      publicacoes: dados?.publicacoes,
      documentos: dados?.documentos,
      problemas: dados?.problemas,
      eleicoes_cipa: dados?.eleicoes_cipa,
      formularios: dados?.formularios,
      escolaridade: dados?.escolaridade ?? 0,
    });
  }

  return { statusCode: api.statusCode, dados: dados };
}

export { listarPendencias };
